"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocationFieldAngleInputState = exports.LocationFieldInputState = void 0;
const i18n_1 = require("../../i18n");
const number_input_state_1 = require("./number.input.state");
const RE_ANGLE = /^\s*[+-]?((\.\d+)|(\d+(\.\d+)?))°?$/;
class LocationFieldInputState extends number_input_state_1.NumberInputState {
    constructor(label, precision = 6, minimumInputPrecision = 0) {
        super(label, precision, minimumInputPrecision);
        this.isLabelShown = false;
        this.isErrorShown = false;
    }
}
exports.LocationFieldInputState = LocationFieldInputState;
class LocationFieldAngleInputState extends LocationFieldInputState {
    constructor(label, precision = 6, minimumInputPrecision = 0, maxValue = 0) {
        super(label, precision, minimumInputPrecision);
        this.isLabelShown = false;
        this.isErrorShown = false;
        this.maxValue = maxValue;
    }
    parseInputValue(val) {
        if (val.match(RE_ANGLE) == null) {
            this.setError(i18n_1.T.NUMBER_INVALID);
            return NaN;
        }
        //if the input value is a valid angle, we remove the potential '°' character and then manage it as a regular number
        val = val.split('°').join('');
        let res = super.parseInputValue(val);
        if (this.maxValue !== 0 && (Math.abs(res) > this.maxValue)) {
            this.setError((0, i18n_1.Translate)(i18n_1.T.LOCATION_FIELD_OUT_OF_RANGE, { field: (0, i18n_1.Translate)(this.label), maxValue: this.maxValue }));
            return null;
        }
        return res;
    }
}
exports.LocationFieldAngleInputState = LocationFieldAngleInputState;
//# sourceMappingURL=LocationField.input.state.js.map